import _regeneratorRuntime from "C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.
import Consent from "./Consent.js";

var ConsentManagerContract = require('../contracts/ConsentManager.json');

var ConsentManager =
/*#__PURE__*/
function () {
  function ConsentManager(FDSAccount) {
    _classCallCheck(this, ConsentManager);

    var contractAddress = '0xB57caE1557420Ed7bD4Dc9647a6e51c509F81893';
    this.account = FDSAccount;
    this.cm = FDSAccount.Tx.getContract(this.account, ConsentManagerContract.abi, contractAddress);
  } // create a consent


  _createClass(ConsentManager, [{
    key: "createConsent",
    value: function createConsent(userAddress, subjectAddress, swarmHash) {
      return this.cm.send('createConsent', [userAddress, subjectAddress, swarmHash]);
    } // get consent at

  }, {
    key: "getConsentAt",
    value: function () {
      var _getConsentAt = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(consentContractAddress) {
        var consentObject;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new Consent(this.account, consentContractAddress, "0x0");

              case 2:
                consentObject = _context.sent;
                return _context.abrupt("return", consentObject);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getConsentAt(_x) {
        return _getConsentAt.apply(this, arguments);
      }

      return getConsentAt;
    }() // get user consents

  }, {
    key: "getUserConsents",
    value: function getUserConsents() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.cm.call('getUserConsents', []);
    } // get subject consents

  }, {
    key: "getSubjectConsents",
    value: function getSubjectConsents() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.cm.call('getSubjectConsents', []);
    } // get consents for swarmHash

  }, {
    key: "getConsentsFor",
    value: function getConsentsFor(swarmHash) {
      return this.cm.call('getConsentsFor', [swarmHash]);
    } // update existing consents with new location

  }, {
    key: "updateConsent",
    value: function updateConsent(consentAddress, swarmHash) {
      return this.cm.send('updateConsent', [consentAddress, swarmHash]);
    }
  }]);

  return ConsentManager;
}();

export default ConsentManager;